// extracted by mini-css-extract-plugin
export default {"dialog":"qvrx_oU4DmIFBSDt","paragraph":"YBuvwkK7KwsD66fg"};